import { render, staticRenderFns } from "./CreateTreatmentActions.vue?vue&type=template&id=1e672d4e&scoped=true"
import script from "./CreateTreatmentActions.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentActions.vue?vue&type=script&lang=js"
import style0 from "./CreateTreatmentActions.vue?vue&type=style&index=0&id=1e672d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e672d4e",
  null
  
)

export default component.exports